export const COMPANY = {
  name: "Vikas Rolls Private Limited",
  shortName: "Vikas Rolls",
  founded: 1970,
  tagline: "Precision Rolls. Engineered for Performance.",
  address: {
    label: "Office & Works",
    lines: ["1273–1274, MIE, Red Cross Road", "Bahadurgarh, Haryana 124507, India"],
    plusCode: "MXJ4+7H Bahadurgarh, Haryana, India",
  },
  phone: { primary: "+91 98104 09131" },
  whatsapp: "https://wa.me/919810409131",
  emails: { info: "info@vikasrolls.in", sales: "sales@vikasrolls.in" },
  mapEmbedUrl: "https://www.google.com/maps?q=Vikas+Rolls+Private+Limited,+Bahadurgarh,+Haryana,+India&ll=28.680908,76.956345&z=16&output=embed",
  mapsLink: "https://maps.app.goo.gl/cZfEuyooNxN6HCNw8",
  businessHoursPlaceholder: "Mon – Sat, 9:00 AM – 6:00 PM IST",
  director: "Mr. U. S. Maggu",
  certification: {
    standard: "ISO 9001:2015",
    certificateNo: "QCC/A66B/0326",
    issueDate: "20 March 2026",
    expiryDate: "19 March 2029",
    scope: "Manufacturers of Elastomeric and Steel Rollers",
    body: "Quality Control Certification (EAS — IAF member)",
  },
};

export const tel = (n) => `tel:${n.replace(/\s/g, "")}`;
export const mail = (e) => `mailto:${e}`;
